import { render, staticRenderFns } from "./PolicyAlerts.vue?vue&type=template&id=789b5ebb&scoped=true&"
import script from "./PolicyAlerts.vue?vue&type=script&lang=js&"
export * from "./PolicyAlerts.vue?vue&type=script&lang=js&"
import style0 from "./PolicyAlerts.vue?vue&type=style&index=0&id=789b5ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789b5ebb",
  null
  
)

export default component.exports